import { createAddToCartListFormData, listActionStandard, openOptionalModal } from './helper';
import { messageBoxSuccess, messageBoxError } from '../components/message-box';

class AddToCart {
  public groupTeaserButtons: NodeListOf<HTMLElement>;

  public productTeaserButtons: NodeListOf<HTMLElement>;

  public wishlistContent: any;

  public cartIconHeader: HTMLElement | null;

  public cartIconHeaderInner: SVGTSpanElement | null | undefined;

  constructor(wishlistContent: any) {
    this.wishlistContent = wishlistContent;
  }

  async addGroupToCart(e: Event) {
    e.preventDefault();

    const requests = [];

    document.body.classList.add('loading-bar');

    const listId = (e.currentTarget as HTMLElement).dataset.listId;

    try {
      let allProductsAmount = 0;
      let addedToCartProductsAmount = 0;
      let configurationInListGlobal = false;
      let configurationInList = false;
      let unavailableProductInList = false;
      let unavailableProductInListGlobal = false;
      let accessoriesProducts: { id: any; quantity: any; }[] = [];

      const items = this.wishlistContent.filter((list: any) => list.list_id == listId)[0].items;

      items.forEach((item: any) => {
        allProductsAmount += 1;

        if (item.hide_price) {
          configurationInList = true;
          configurationInListGlobal = true;
        }
        if (!item.purchasable && !item.hide_price) {
          unavailableProductInList = true;
          unavailableProductInListGlobal = true;
        }
        if (item['sku'] != null && item['sku'] != "" && item['with_accessories'] != null && item['with_accessories'] != "") {
          accessoriesProducts.push({
            'id' : item['with_accessories'],
            'quantity' : item.quantity
          });
        }
      });

      if (!configurationInList && !unavailableProductInList) {
        addedToCartProductsAmount = allProductsAmount;
        requests.push(listActionStandard(createAddToCartListFormData(listId as string)));
      } else {
        for (const item of items) {
          if (!item.hide_price && item.purchasable) {
            addedToCartProductsAmount += 1;
            const addItemToCartFormdata = createAddToCartListFormData(listId as string);

            addItemToCartFormdata.append(`purchasables[${item.wishlist_id}]`, item.wishlist_id);
            addItemToCartFormdata.append(`purchasables[${item.wishlist_id}][qty]`, item.quantity);

            requests.push(listActionStandard(addItemToCartFormdata));
          }
        };
      }

      for (const section of this.wishlistContent.filter((list: any) => list.list_id == listId)[0].sections) {
        let sectionItemsAmount = 0;
        let configurationInSection = false;
        let unavailableProductInSection = false;

        section.items.forEach((item: any) => {
          allProductsAmount += 1;
          sectionItemsAmount += 1;

          if (item.hide_price) {
            configurationInSection = true;
            configurationInListGlobal = true;
          }
          if (!item.purchasable && !item.hide_price) {
            unavailableProductInSection = true;
            unavailableProductInListGlobal = true;
          }
          if (item['sku'] != null && item['sku'] != "" && item['with_accessories'] != null && item['with_accessories'] != "") {
            accessoriesProducts.push({
              'id' : item['with_accessories'],
              'quantity' : item.quantity
            });
          }
        });

        if (!configurationInSection && !unavailableProductInSection) {
          addedToCartProductsAmount += sectionItemsAmount;
          requests.push(listActionStandard(createAddToCartListFormData(section.section_id)));
        } else {
          for (const item of section.items) {
            if (!item.hide_price && item.purchasable) {
              addedToCartProductsAmount += 1;
              const addItemToCartFormdata = createAddToCartListFormData(section.section_id);

              addItemToCartFormdata.append(`purchasables[${item.wishlist_id}]`, item.wishlist_id);
              addItemToCartFormdata.append(`purchasables[${item.wishlist_id}][qty]`, item.quantity);

              requests.push(listActionStandard(addItemToCartFormdata));
            }
          };
        }
      }

      await Promise.all(requests);

      if (accessoriesProducts.length > 0) {
        const requiredAccessoriesEvent = new CustomEvent('formpopup:open', {
          detail: {
            form: 'required-accessories',
            type: 'form',
            size: 'large--py-0',
            target: 'form-popup',
            products: JSON.stringify(accessoriesProducts),
            hideMessageBox: true,
          },
        } as any);

        document.dispatchEvent(requiredAccessoriesEvent);

        const handleAfterModal = () => {
          if (configurationInListGlobal || unavailableProductInListGlobal) {
            messageBoxSuccess({
              contentDe: `${addedToCartProductsAmount} von ${allProductsAmount} Produkten wurden erfolgreich zum Warenkorb hinzugefügt.`,
              contentEn: `${addedToCartProductsAmount} of ${allProductsAmount} products successfully added to cart.`,
            });
          } else {
            messageBoxSuccess({
              contentDe: 'Gruppe wurde erfolgreich zum Warenkorb hinzugefügt.',
              contentEn: 'Successfully added group to cart.',
            });
          }

          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { showCart: true },
          } as any));

          setTimeout(() => {
            openOptionalModal(configurationInListGlobal, unavailableProductInListGlobal);
          }, 4500);

          window.removeEventListener('required-accessories:close', handleAfterModal);
        };

        window.addEventListener('required-accessories:close', handleAfterModal);
      } else {
        messageBoxSuccess({
          contentDe: 'Gruppe wurde erfolgreich zum Warenkorb hinzugefügt.',
          contentEn: 'Successfully added group to cart.',
        });

        setTimeout(() => {
          openOptionalModal(configurationInListGlobal, unavailableProductInListGlobal);
        }, 4500);
      }
      const apiBaseUrl = document.body.dataset.apiBaseUrl;
      const cartResponse = await fetch(`${apiBaseUrl}api/v1/cart`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
        },
      });
      const cart = await cartResponse.json();

      this.cartIconHeader = document.querySelector('.l-header__actions-button-cart .js-l-header__cart-icon');
      this.cartIconHeaderInner = this.cartIconHeader?.querySelector('tspan');

      if (this.cartIconHeader) {
        this.cartIconHeader.style.display = 'block';
      }

      if (this.cartIconHeaderInner) {
        let sum = 0;
        let alreadyCounted: any[] = [];
        cart.lineItems.forEach((lineItem: any) => {
          if (!lineItem.options?._configuratorId || lineItem.options?._configuratorMainItem === 'yes') {
            sum += lineItem.qty;
          }
          alreadyCounted.push(lineItem.options?._configuratorId);
        });
        this.cartIconHeaderInner.innerHTML = String(sum);
      }

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { showCart: accessoriesProducts.length > 0 ? false : true },
      } as any));

      document.body.classList.remove('loading-bar');
    } catch (e) {
      console.error(e);

      document.body.classList.remove('loading-bar');

      messageBoxError({
        contentDe: 'Es ist ein Fehler aufgetreten. Gruppe konnte nicht zum Warenkorb hinzugefügt werden.',
        contentEn: 'An error appeared. Could not add group to cart.',
      });
    }
  }

  async addProductToCart(e: Event) {
    e.preventDefault();

    document.body.classList.add('loading-bar');

    const itemId = (e.currentTarget as HTMLElement).dataset.wishlistId;
    const listId = (e.currentTarget as HTMLElement).dataset.listId;
    const quantity = (e.currentTarget as HTMLElement).dataset.quantity || '';
    const elementId = (e.currentTarget as HTMLElement).dataset.elementId;
    let showCart = true;
    let accessoryProduct = null;

    try {
      if ((e.currentTarget as HTMLElement).dataset.isRoomleConfig) {
        const roomleConfigId = (e.currentTarget as HTMLElement).dataset.elementId;

        const getEntryRequestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            'item_id': elementId,
          }),
        };
        const apiBaseUrl = document.body.dataset.apiBaseUrl;
        // @ts-ignore
        const articlesResponse = await fetch(`${apiBaseUrl}api/v1/roomle/get-roomle-config-entry`, getEntryRequestOptions);
        const articles = await articlesResponse.json();

        const addToCartRequestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            'articles': articles,
            'saved_entry': elementId,
          }),
        };
        // @ts-ignore
        await fetch(`${apiBaseUrl}api/v1/roomle/add-to-cart`, addToCartRequestOptions);

        if (elementId) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null }); // reset data layer items
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              // currency: currency, // currency
              // value: selectedProduct.price.price, // price including discount
              content_type: 'product', // static
              content_ids: [elementId], // SKU
              items: [
                {
                  item_id: elementId, // SKU
                  // item_name: selectedProduct.title, // product name
                  // item_category: selectedProduct.product_type_label, // product category (category ID would be fine as well)
                  configuration_id: elementId, // configuration ID, if applicable
                  // price: selectedProduct.price.price, // original price
                  // discount: null, // discount, if applicable
                  quantity: quantity // static
                }
              ]
            }
          });
        }
      } else {

        const addItemToCartFormdata = createAddToCartListFormData(listId as string);
        addItemToCartFormdata.append(`purchasables[${itemId}][qty]`, quantity);
        await listActionStandard(addItemToCartFormdata);


        for (const accessoriesProduct of this.wishlistContent.filter((list: any) => list.list_id == listId)[0].items) {
          if (accessoriesProduct['sku'] != null && accessoriesProduct['id'] == elementId && accessoriesProduct['with_accessories'] != null) {
            accessoryProduct = {
              'id' : accessoriesProduct['with_accessories'],
              'quantity' : accessoriesProduct.quantity
            };
          }
        }

        if (accessoryProduct) {
          const requiredAccessoriesEvent = new CustomEvent('formpopup:open', {
            detail: {
              form: 'required-accessories',
              type: 'form',
              size: 'large--py-0',
              target: 'form-popup',
              products: JSON.stringify([accessoryProduct])
            },
          } as any);

          document.dispatchEvent(requiredAccessoriesEvent);

          showCart = false;
        }

        if (elementId) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null }); // reset data layer items
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              // currency: currency, // currency
              // value: selectedProduct.price.price, // price including discount
              content_type: 'product', // static
              content_ids: [elementId], // SKU
              items: [
                {
                  item_id: elementId, // SKU
                  // item_name: selectedProduct.title, // product name
                  // item_category: selectedProduct.product_type_label, // product category (category ID would be fine as well)
                  // configuration_id: null, // configuration ID, if applicable
                  // price: selectedProduct.price.price, // original price
                  // discount: null, // discount, if applicable
                  quantity: quantity // static
                }
              ]
            }
          });
        }
      }

      if (!accessoryProduct) {
        messageBoxSuccess({
          contentDe: 'Produkt wurde erfolgreich zum Warenkorb hinzugefügt.',
          contentEn: 'Successfully added product to cart.',
        });
      }
      const apiBaseUrl = document.body.dataset.apiBaseUrl;
      const cartResponse = await fetch(`${apiBaseUrl}api/v1/cart`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
        },
      });
      const cart = await cartResponse.json();

      this.cartIconHeader = document.querySelector('.l-header__actions-button-cart .js-l-header__cart-icon');
      this.cartIconHeaderInner = this.cartIconHeader?.querySelector('tspan');

      if (this.cartIconHeader) {
        this.cartIconHeader.style.display = 'block';
      }

      if (this.cartIconHeaderInner) {
        let sum = 0;
        let alreadyCounted: any[] = [];
        cart.lineItems.forEach((lineItem: any) => {
          if (!lineItem.options?._configuratorId || lineItem.options?._configuratorMainItem === 'yes') {
            sum += lineItem.qty;
          }
          alreadyCounted.push(lineItem.options?._configuratorId);
        });
        this.cartIconHeaderInner.innerHTML = String(sum);
      }

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { showCart: showCart },
      } as any));

      document.body.classList.remove('loading-bar');
    } catch (e) {
      console.error(e);

      document.body.classList.remove('loading-bar');

      messageBoxError({
        contentDe: 'Es ist ein Fehler aufgetreten. Produkt konnte nicht zum Warenkorb hinzugefügt werden.',
        contentEn: 'An error appeared. Could not add product to cart.',
      });
    }
  }

  bindings() {
    if (this.groupTeaserButtons) {
      this.groupTeaserButtons.forEach((button) => {
        button.addEventListener('click', this.addGroupToCart.bind(this));
      });
    }

    if (this.productTeaserButtons) {
      this.productTeaserButtons.forEach((button) => {
        button.addEventListener('click', this.addProductToCart.bind(this));
      });
    }
  }

  cache() {
    this.groupTeaserButtons = document.querySelectorAll('.m-wishlist-group-teaser .js-add-to-cart');
    this.productTeaserButtons = document.querySelectorAll('.m-wishlist-product-teaser .js-add-to-cart');
    this.cartIconHeader = document.querySelector('.l-header__actions-button-cart .js-l-header__cart-icon');
    this.cartIconHeaderInner = this.cartIconHeader?.querySelector('tspan');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default AddToCart;
